/* global axios */
import WhatsAppSipApiClient from './index';

class WhatsAppSipSupervisorAPI extends WhatsAppSipApiClient {
  constructor() {
    super('supervisor');
  }

  getDashboard() {
    return axios.get(`${this.url}/dashboard`);
  }

  getAgents() {
    return axios.get(`${this.url}/agents`);
  }

  getCalls() {
    return axios.get(`${this.url}/calls`);
  }

  getMetrics(params) {
    return axios.get(`${this.url}/metrics`, { params });
  }

  snoop(data) {
    return axios.post(`${this.url}/snoop`, data);
  }

  stopSnoop(bridgeId) {
    return axios.delete(
      `${this.url}/snoop?bridge_id=${encodeURIComponent(bridgeId)}`
    );
  }
}

export default new WhatsAppSipSupervisorAPI();
